import { Controller } from "@hotwired/stimulus"

// Le attese aperte in questa pagina (pollRef di OfficialDocs): chiavi dei frame il cui esito va annunciato. Stanno nel
// modulo, non nel DOM: un refresh della pagina (morph o elenco riletto) che ridisegna le schede non le perde.
const attese = new Set()

// Ricarica un Turbo Frame ogni `intervallo` ms finché il server lo rende con `attivo` (es. official_docs_status ==
// "running"): riserva quando gli aggiornamenti via Cable non arrivano. Il controller sta DENTRO il frame, così ogni
// risposta lo ricrea con il suo `attivo`; i tentativi si contano sul frame (data-poll-tentativi). Con `massimo` (0 =
// senza limite) la risposta del giro numero `massimo` ancora attiva non programma altri giri ed emette "poll:scaduto"
// (es. il toast «Ingestione troppo lunga, riprova» al 30° tentativo, come tries >= 30 dell'originale).
// Con `url` il frame si rilegge da quell'indirizzo: un frame reso senza src (nessuna richiesta quando entra nella
// pagina, anche da un <turbo-stream>) lo riceve al primo giro.
// Con `attesa` (una chiave, es. "official-docs-<id>"): `avvia` apre l'attesa; finché è aperta ogni giro chiede
// l'indirizzo con attesa=1 (il server risponde con l'esito quando il lavoro è finito) e una scheda ridisegnata già
// ferma la rilegge subito una volta; `concluso` (la risposta con l'esito) la chiude.
// Un `attivo` cambiato da un morph (il controller resta connesso) riprogramma il giro. Con l'attesa aperta ogni giro ha
// anche un giro di riserva: se la risposta non sostituisce il frame (204, errore di rete) il sondaggio riprova invece
// di fermarsi e perdere l'esito; la risposta che sostituisce il frame lo annulla (disconnect).
//   <turbo-frame id="official-docs-1"><div data-controller="poll" data-poll-attivo-value="true"
//     data-poll-intervallo-value="3000" data-poll-url-value="/…"></div>…</turbo-frame>
export default class extends Controller {
  static values = {
    attivo: Boolean, intervallo: { type: Number, default: 3000 }, massimo: { type: Number, default: 0 }, url: String,
    attesa: String, avvia: Boolean, concluso: Boolean
  }

  connect() {
    this.frame = this.element.closest("turbo-frame")
    if (!this.frame) return
    this.programma()
  }

  attivoValueChanged() {
    if (this.frame) this.programma()
  }

  programma() {
    clearTimeout(this.timer)
    clearTimeout(this.riserva)
    if (this.attesaValue) {
      if (this.conclusoValue) attese.delete(this.attesaValue)
      else if (this.avviaValue) attese.add(this.attesaValue)
    }
    if (!this.attivoValue) {
      delete this.frame.dataset.pollTentativi
      // l'esito di un'attesa aperta non va perso se la scheda arriva già ferma (refresh della pagina)
      if (this.inAttesa) this.timer = setTimeout(() => this.ricarica(), 0)
      return
    }
    const fatti = Number(this.frame.dataset.pollTentativi || 0)
    if (this.massimoValue > 0 && fatti >= this.massimoValue) {
      delete this.frame.dataset.pollTentativi
      this.dispatch("scaduto", { target: this.frame })
      return
    }
    this.timer = setTimeout(() => this.ricarica(), this.intervalloValue)
  }

  disconnect() {
    clearTimeout(this.timer)
    clearTimeout(this.riserva)
  }

  get inAttesa() {
    return Boolean(this.attesaValue) && attese.has(this.attesaValue)
  }

  ricarica() {
    clearTimeout(this.riserva)
    if (this.inAttesa) this.riserva = setTimeout(() => this.ricarica(), Math.max(this.intervalloValue, 1000) * 3)
    this.frame.dataset.pollTentativi = String(Number(this.frame.dataset.pollTentativi || 0) + 1)
    let url = this.urlValue && new URL(this.urlValue, window.location.href)
    if (url && this.inAttesa) url.searchParams.set("attesa", "1")
    url = url && url.href
    if (url && url !== (this.frame.src && new URL(this.frame.src, window.location.href).href)) this.frame.src = url
    else if (this.frame.src) this.frame.reload()
    else this.frame.src = window.location.href
  }
}
